<template>
  <div class="video-map">
    <div id="video-map" :class="mapClass"></div>
    <div class="map__side">
      <div class="side__logo">
        Я видел <br />
        редкого <br />
        пациента
      </div>
      <div class="side__filters">
        <div class="filters__title">Видеоролики <br />по стране</div>
        <ul class="filters__items">
          <li
              v-for="filter in filters"
              :key="filter.id"
              class="filter"
              :class="filterClass(filter)"
          >
            <label>
              <i></i>
              <input
                  type="radio"
                  :value="filter.id"
                  v-model="disease"
                  :disabled="!filterCount(filter)"
              />
              {{ filter.name }}
            </label>
          </li>
        </ul>
      </div>
    </div>
    <div class="map__bottom">
      <svg width="36" height="36" viewBox="0 0 36 36">
        <path fill="rgba(255,255,255,0)" d="M0 0h36v36H0z" />
        <g fill="#fff">
          <path d="M15.6 9.8h-2v3.8H9.8v2h3.8v3.8h2v-3.8h3.8v-2h-3.8z" />
          <path
              d="M21.8 21a9.6 9.6 0 10-7.2 3.2 9.6 9.6 0 007.2-3.3zm-7.2 1.3a7.7 7.7 0 117.2-10.4 7.7 7.7 0 010 5.4 7.7 7.7 0 01-7.2 5z"
          />
          <path d="M23.2 21.3l-1.4 1.4-.5.5.5.5 8.1 8.1 2-1.9z" />
        </g>
      </svg>
      <span>
        Для ознакомления с информацией по региону необходимо увеличить карту с
        помощью колесика мышки
      </span>
    </div>
    <div class="map__info" v-if="info">
      <span class="info__close" @click="info = null">
        <svg width="32" height="32" viewBox="0 0 32 32">
          <path
              fill="#4B7ED5"
              fill-rule="evenodd"
              d="M4.55 4.54a15.54 15.54 0 1021.97 0 15.54 15.54 0 00-21.97 0zm19.1 16.15l-2.96 2.95-5.15-5.15-5.16 5.15-2.95-2.96 5.15-5.15-5.15-5.16 2.95-2.95 5.16 5.15 5.15-5.15 2.96 2.95-5.15 5.16z"
          />
        </svg>
      </span>
      <div class="info__content" v-html="info"></div>
    </div>
    <scroller
        :class="scrollerClasses"
        @video="showVideo"
        @info="showInfo"
        @close="clearList"
        class="map__list"
        :videos="listVideos"
        :type="this.disease"
        :title="listTitle"
    />
  </div>
</template>

<script>
const $ = window.jQuery;
import MapData from "@/assets/map";
import svgPanZoom from "svg-pan-zoom";
import Scroller from "@/components/scroller";

Array.prototype.max = function() {
  return Math.max.apply(null, this);
};

Array.prototype.min = function() {
  return Math.min.apply(null, this);
};

export default {
  components: {
    Scroller
  },
  data() {
    return {
      map: null,
      zoom: null,
      info: null,
      scale: 0.8,
      scaleBreakpoint: 1.5,
      listVideos: null,
      listTitle: null,
      disease: "__all",
      mapData: MapData,
      filters: [
        {
          id: "__all",
          name: "Все видео"
        },
        {
          id: "mps",
          name: "МПС I"
        },
        {
          id: "pompe",
          name: "Помпе"
        },
        {
          id: "fabri",
          name: "Фабри"
        },
        {
          id: "niemann-pika",
          name: "Ниманн-Пик"
        }
      ]
    };
  },
  props: {
    videos: {
      type: Array,
      default: null
    }
  },
  computed: {
    mapClass() {
      return {
        ["video-map--" + this.type.toLowerCase()]: !!this.type
      };
    },
    scrollerClasses() {
      return {
        "map__list--opened": this.listVideos && this.listVideos.length
      };
    },
    scrollerTitle() {
      return this.listVideos ? this.listVideos[0].region_name : "";
    },
    markersFill() {
      switch (this.disease) {
        case "mps":
          return "#a8d08d";
        case "pompe":
          return "#bdd7ee";
        case "fabri":
          return "#ffd965";
        case "niemann-pika":
          return "#f78e94";
        default:
          return "#848484";
      }
    },
    markers() {
      const markersList = [];
      this.videos
          .filter(
              video => video.disease == this.disease || this.disease === "__all"
          )
          .forEach(video => {
            const marker = markersList.findIndex(
                el => el.region === video.region
            );
            if (marker > -1) {
              markersList[marker].videos.push(video);
            } else {
              markersList.push({
                coords: video.location,
                name: "1",
                group: video.disease,
                region: video.region,
                style: this.markerStyle,
                type: this.type,
                videos: [video]
              });
            }
          });
      const counts = markersList.map(m => m.videos.length);

      const maxVideos = counts.max();
      const minVideos = counts.min();

      return markersList.map(m => {
        const count = m.videos.length;
        const r =
            maxVideos === minVideos
                ? window.settings.radius.min
                : window.settings.radius.min +
                ((window.settings.radius.max - window.settings.radius.min) *
                    (count - minVideos)) /
                (maxVideos - minVideos);
        return {
          ...m,
          style: {
            ...m.style,
            r: r / this.scale
          }
        };
      });
    },
    markerStyle() {
      return {
        fill: this.markersFill
      };
    },
    type() {
      return this.scale > this.scaleBreakpoint ? "RG" : "FD";
    }
  },
  watch: {
    disease() {
      this.map.params.markerStyle.selected.fill = this.markersFill;
      this.listVideos = null;
      this.updateMarkers();
    },
    type() {
      this.updateMarkers();
    },
    scale() {
      this.updateMarkers();
      this.map.params.markerLabelStyle.initial["font-size"] =
          16 / this.scale + "px";
    }
  },
  mounted() {
    const vm = this;
    $.fn.vectorMap("addMap", "ru_merc", MapData);

    $("#video-map").vectorMap({
      map: "ru_merc",
      zoomOnScroll: false,
      hoverOpacity: 1,
      backgroundColor: "transparent",
      zoomOnScrollSpeed: 1,
      panOnDrag: false,
      regionsSelectable: false,
      labels: {
        regions: {
          render(code) {
            return MapData.paths[code].name;
          },
          offsets(code) {
            return MapData.paths[code].offset;
          }
        },
        markers: {
          render(i) {
            return vm.markers[i].videos.length > 1
                ? vm.markers[i].videos.length
                : false;
          },
          offsets(i) {
            if (vm.map) {
              const r = vm.markers[i].style.r;
              // const transX = vm.map.transX;
              // const scale = vm.map.scale;
              // const circleX = vm.markers[i].coords[0];
              // const labelX = circleX / scale - transX;
              // const x = labelX * scale + transX * scale + 5 + r;

              return [-1 * (5 + r), 0];
            } else {
              return [0, 0];
            }
          }
        }
      },
      regionLabelStyle: {
        initial: {
          fill: "#000000",
          "font-family": "Circe",
          "font-weight": "normal",
          "font-size": "4px"
        }
      },
      markerLabelStyle: {
        initial: {
          fill: "#ffffff",
          "font-family": "Circe",
          "font-weight": "normal",
          "font-size": "16px"
        }
      },
      regionStyle: {
        initial: {
          fill: "white",
          "fill-opacity": 0.5,
          stroke: "white",
          "stroke-width": 1.5,
          "stroke-opacity": 1
        },
        hover: {
          "fill-opacity": 0.6,
          cursor: "pointer"
        },
        selectedHover: {}
      },
      markers: this.markers,
      markerStyle: {
        initial: {
          r: 5,
          stroke: "#FFFFFF",
          "stroke-width": 1
        },
        hover: {
          stroke: "#FFFFFF",
          "stroke-width": 1
        },
        selected: {
          "stroke-width": 2,
          fill: this.markersFill
        }
      },
      onMarkerClick: (e, code) => {
        const selectedMarkers = this.map.getSelectedMarkers();
        if (!selectedMarkers.includes(code)) {
          this.map.clearSelectedMarkers();
          this.map.setSelectedMarkers(code);
          this.listVideos = this.markers[code].videos;
          this.listTitle = this.listVideos
              ? this.getRegionName("RG-" + this.listVideos[0].region)
              : "";
        } else {
          this.map.clearSelectedMarkers();
          this.listVideos = null;
          this.listTitle = null;
        }
      },
      onRegionClick: (e, code) => {
        this.listTitle = this.getRegionName(code);
        this.listVideos = this.videos.filter(el => {
          return (
              (el.disease === this.disease || this.disease === "__all") &&
              (code.indexOf("FD-") === 0
                  ? code === "FD-" + el.district
                  : code === "RG-" + el.region)
          );
        });
      }
    });

    this.map = $("#video-map").vectorMap("get", "mapObject");

    this.zoom = svgPanZoom("#video-map svg", {
      viewportSelector: ".svg-pan-zoom_viewport",
      zoomEnabled: true,
      controlIconsEnabled: false,
      minZoom: 0.8,
      maxZoom: 3,
      panEnabled: true,
      center: true,
      onZoom(scale) {
        vm.scale = scale;
      }
    });
    this.zoom.zoom(this.scale);
    this.zoom.pan({ x: 200, y: 0 });
  },
  methods: {
    getRegionName(code) {
      const region = this.mapData.paths[code];
      return region ? region.name : "Видео";
    },
    clearList() {
      this.map.clearSelectedMarkers();
      this.listVideos = null;
      this.info = null;
    },
    showVideo(video) {
      this.$emit("video", video);
    },
    showInfo(info) {
      this.info = info;
    },
    updateMarkers() {
      this.map.removeAllMarkers();
      this.map.addMarkers(this.markers);
      this.map.updateSize();
    },
    filterCount(filter) {
      return filter.id === "__all"
          ? this.videos.length
          : this.videos.filter(el => el.disease === filter.id).length;
    },
    filterClass(filter) {
      return {
        ["filter--" + filter.id]: !!filter.id,
        "filter--disabled": !this.filterCount(filter),
        "filter--active": filter.id === this.disease
      };
    }
  }
};
</script>
<style lang="scss">
.jvectormap-container {
  height: 100%;
}
.jvectormap-zoomin,
.jvectormap-zoomout {
  display: none;
}
.jvectormap-region {
  &[data-code^="RG"] {
    visibility: hidden;

    .video-map--rg & {
      visibility: visible;
    }
  }
  &[data-code^="FD"] {
    .video-map--rg & {
      visibility: hidden;
    }
  }
}
.jvectormap-marker {
  text-anchor: middle;
}
text.jvectormap-region[data-code^="FD"] {
  font-size: 14px;
  visibility: hidden;
}
</style>
<style lang="scss" scoped>
.video-map {
  height: 600px;
  margin: 0 0 32px;
  background: url(../assets/bg.jpg) center;
  background-size: cover;
  position: relative;
  overflow: hidden;

  @media (max-width: 1023px) {
    height: 440px;
  }
}
#video-map {
  height: 100%;
  position: relative;
}
.info {
  &__content {
    display: block;
    font-size: 16px;

    ::v-deep {
      p {
        margin: 0;

        + p {
          margin: 1em 0 0;
        }
      }
    }
  }
  &__close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
}
.map {
  overflow: hidden;
  &__side {
    position: absolute;
    left: 16px;
    top: 16px;
    width: 200px;
  }
  &__bottom {
    position: absolute;
    bottom: 0;
    color: #fff;
    left: 0;
    right: 0;
    background: rgba(#3445b7, 0.5);
    border-radius: 32px 32px 0 0;
    padding: 8px 16px;
    display: flex;
    align-items: center;

    svg {
      vertical-align: middle;
      margin: 0 8px 0 0;
    }
  }
  &__info {
    position: absolute;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.5);
    right: 280px;
    top: 16px;
    width: 270px;
    transition: all 0.3s;
    padding: 45px 20px 20px;
    z-index: 3;
  }
  &__list {
    position: absolute;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.5);
    right: 16px;
    top: 16px;
    bottom: 64px;
    width: 270px;
    transform: translate(50%, 0);
    opacity: 0;
    transition: all 0.3s;

    &--opened {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
}
.side {
  &__logo {
    margin-bottom: 8px;
    border-radius: 20px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    font-size: 14px;
    line-height: 16px;
    font-family: Circe;

    &:before {
      content: "";
      background: url(../assets/logo.svg);
      background-size: 100% 100%;
      width: 96px;
      height: 58px;
      margin: 0 16px 0 0;
    }
  }
  &__filters {
    margin-bottom: 8px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    padding: 24px;
  }
}
.filters {
  &__title {
    color: #3722a3;
    font-size: 20px;
    line-height: 1;
    border-bottom: 1px solid #ebebeb;
    padding: 0 0 12px;
    margin: 0 0 12px;
  }
  &__items {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 16px;
    color: #3a3a3a;

    li {
      margin: 8px 0;

      &:last-child {
        margin: 0;
      }
    }
  }
}
.filter {
  position: relative;
  margin: 4px 0;
  display: block;

  label {
    cursor: pointer;
    overflow: hidden;
  }

  input {
    position: absolute;
    opacity: 0.01;
    cursor: pointer;
    left: -50px;
  }

  i {
    position: relative;
    display: inline-block;
    width: 14px;
    height: 14px;
    background: #848484;
    border-radius: 50%;
    vertical-align: -0.1em;
    margin: 0 4px 0 0;

    &:before {
      content: "";
      position: absolute;
      left: -3px;
      right: -3px;
      top: -3px;
      bottom: -3px;
      border-radius: 50%;
      border: 1px solid #848484;
      transform: scale(0.7);
      opacity: 0;
      transition: all 0.2s;
    }
  }
  &--disabled {
    opacity: 0.5;

    label {
      cursor: default;
    }
  }
  &--active {
    i {
      &:before {
        transform: scale(1);
        opacity: 1;
      }
    }
  }
  &--mps {
    i {
      background: #a8d08d;
    }
  }
  &--pompe {
    i {
      background: #bdd7ee;
    }
  }
  &--fabri {
    i {
      background: #ffd965;
    }
  }
  &--niemann-pika {
    i {
      background: #f78e94;
    }
  }
}
</style>
